import { Section, Text } from "@react-email/components";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant, User } from "@/types";

interface ErrorReportEmailProps {
    error: unknown;
    errorInfo: unknown;
    user?: User;
    url: string;
    feedback: string;
    tenant: ITenant | null;
}

const ErrorReportEmail = ({
    error,
    errorInfo,
    user,
    feedback,
    url,
    tenant,
}: ErrorReportEmailProps) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const preview = is1TemplateTenant ? "1Template" : "Your";
    const subdomain = tenant?.subdomain;
    return (
        <EmailWrapper
            preview={`${preview} [${subdomain}] Error Report`}
            tenant={tenant}
        >
            <EmailHeading>Error Report</EmailHeading>
            <Section>
                <Text>Error: {JSON.stringify(error, null, 2)}</Text>
                <Text>Error Info:</Text>
                <Text style={{ fontSize: "14px" }}>
                    <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                        {JSON.stringify(errorInfo, null, 2)}
                    </pre>
                </Text>
            </Section>
            {user && (
                <Text>
                    Reported by: {user?.email} ({user?.id})
                </Text>
            )}
            {url && <Text>URL: {url}</Text>}
            {feedback && <Text>Additional Feedback: {feedback}</Text>}
        </EmailWrapper>
    );
};

export default ErrorReportEmail;
